export default function handleAdd(setInfo) {
  setInfo((prev) => [...prev, ''])
}
